import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';

/**
 * Include here any default messages that are required
 * in case content can't be loaded (i.e. messages for
 * loading, errors, etc).
 */
export const initialState = fromJS({
  external_content: {
    loadingMsg: 'Loading...'
  }
});

export default createReducer(initialState, {
  [actions.DELETE_TOKEN_FAILED]: (state, action) => state.set('error', action.error),
  [actions.DELETE_TOKEN_SUCCESS]: (state, action) =>
    state.set('external_content', fromJS(action.payload))
});
